import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import MetadataUtils from '../utils/utils-metadata';
import { ProductMetaData } from '../../../models/Product';
import { useLanguage } from '../../contexts/language';
import { useTranslation } from 'react-i18next';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../utils/togglz';
import { useAgeCategorySearchParam } from '../utils/useAgeCategorySearchParam';

type Props = {
    readonly product?: ProductMetaData;
    readonly linked?: boolean;
    readonly isLibx?: boolean;
    readonly loanFormatKey?: string | null;
    readonly shopLanguage: string | undefined;
};

export const ProductAge: FC<Props> = ({ product = {}, linked = true, isLibx = false, loanFormatKey, shopLanguage }) => {
    const { productClass, ageCategory, ageGroup, explicit } = product;
    const language = useLanguage();
    const { t } = useTranslation(['filters']);
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);
    const { searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();

    if (!ageCategory) {
        return null;
    }

    const label = `${t(`ageCategory.${ageCategory}`, {
        defaultValue: ageCategory
    })}${ageGroup ? ` (${ageGroup})` : ''}${explicit ? ' - Explicit' : ''}`;

    if (!linked) {
        return <p>{label}</p>;
    }

    const linkTo = MetadataUtils.createMetaDataLink({
        productClass,
        filter: {
            ageCategory: { include: [ageCategory] },
            ageGroup: ageGroup ? { include: [ageGroup] } : undefined
        },
        extra: { loanFormatKey, language },
        shopLanguage,
        isMultiLanguageShopEnabled,
        ageCategory: ageCategorySearchParam
    });

    return (
        <p>
            <Link to={linkTo}>{label}</Link>
        </p>
    );
};

export default ProductAge;
